import { createSelector } from 'reselect';
import { notMarginAccountsSelector } from 'apex-web/lib/redux/selectors/marginSelectors';
import { RETIREMENT_ACCOUNT_SUFFIX } from '../../constants';

const selectedAccountIdSelector = state => state.user.selectedAccountId;

export const selectedAccountSelector = createSelector(
  [notMarginAccountsSelector, selectedAccountIdSelector],
  (accounts, selectedAccountId) =>
    accounts.find(
      account => Number(account.AccountId) === Number(selectedAccountId)
    )
);

export const isSelectedAccountRetirementSelector = createSelector(
  [selectedAccountSelector],
  selectedAccount =>
    Boolean(selectedAccount?.AccountName?.endsWith(RETIREMENT_ACCOUNT_SUFFIX))
);
